import DiscountIcon from '@mui/icons-material/Discount';
import PromotionsManagement from './PromotionsManagement';



export default {
    list: PromotionsManagement,
    icon: DiscountIcon,
    recordRepresentation: 'reference',
};
